module.exports = __webpack_public_path__ + "img/bank-account.d07e1962.svg";